import React from 'react';
import { useFormik } from 'formik';
import { Alert } from '@mui/material';

export default function Manage2faSmsStep3(props) {
    const dialogSubmit = React.useRef(props.dialogSubmit);

    const formik = useFormik({
        initialValues: {},
        onSubmit: async (values) => {
            props.onValidate();
        },
    });

    React.useEffect(() => {
        if (props.dialogSubmit !== dialogSubmit.current) {
            dialogSubmit.current = props.dialogSubmit;
            formik.handleSubmit();
        }
    });

    return (
        <>
            <Alert sx={{ mt: 2, mb: 2 }} severity="success">
                Phone (SMS) is now available for multi-factor authentication
            </Alert>
        </>
    );
}